import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import { SButton, SIcon } from '@strana-artw/ui-kit';
import { computed, defineComponent } from 'vue';
import { useLegalDocuments } from '@/shared/composables';
import { LEGAL_DOCUMENTS_ACCEPTED, LEGAL_DOCUMENTS_SLUGS } from '@/shared/constants';
import { useAuthStore } from '@/store/authStore';
import { useLegalDocumentsStore } from '@/store/documents';
import { useFeatureFlagsStore } from '@/store/featureFlags';
export default defineComponent({
  name: 'AcceptCookies',
  components: {
    SButton: SButton,
    SIcon: SIcon
  },
  setup: function setup() {
    var _useFeatureFlagsStore = useFeatureFlagsStore(),
      isAcceptPrivateFlag = _useFeatureFlagsStore.isAcceptPrivateFlag;
    var legalDocumentsStore = useLegalDocumentsStore();
    var loadAcceptedLegalDocuments = legalDocumentsStore.loadAcceptedLegalDocuments,
      sendAcceptedLegalDocument = legalDocumentsStore.sendAcceptedLegalDocument;
    var _useLegalDocuments = useLegalDocuments(),
      acceptedLegalDocuments = _useLegalDocuments.acceptedLegalDocuments,
      documentsSlugsWithRole = _useLegalDocuments.documentsSlugsWithRole;
    var loggedIn = useAuthStore().loggedIn;
    var link = computed(function () {
      var path = '/legal-documents';
      return "".concat(path, "/").concat(LEGAL_DOCUMENTS_SLUGS.agreement);
    });
    return {
      loadAcceptedLegalDocuments: loadAcceptedLegalDocuments,
      sendAcceptedLegalDocument: sendAcceptedLegalDocument,
      acceptedLegalDocuments: acceptedLegalDocuments,
      documentsSlugsWithRole: documentsSlugsWithRole,
      loggedIn: loggedIn,
      link: link,
      isAcceptPrivateFlag: isAcceptPrivateFlag
    };
  },
  data: function data() {
    return {
      isLoading: true,
      isAccepted: false,
      isDisabledAcceptedButton: false
    };
  },
  fetch: function fetch() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.loggedIn) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _this.isLoading = true;
            _context.next = 2;
            return _this.loadAcceptedLegalDocuments(_this.documentsSlugsWithRole(true));
          case 2:
            if (!_this.acceptedCookiesDocuments.length) {
              _this.isAccepted = true;
            }
            _this.isLoading = false;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    acceptedCookiesDocuments: function acceptedCookiesDocuments() {
      var slugs = LEGAL_DOCUMENTS_ACCEPTED.cookies;
      return this.acceptedLegalDocuments(slugs);
    }
  },
  methods: {
    handleClick: function handleClick() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.isDisabledAcceptedButton = true;
              _context2.next = 1;
              return _this2.sendAcceptedLegalDocument(_this2.acceptedCookiesDocuments);
            case 1:
              if (!_this2.isAcceptPrivateFlag()) {
                _context2.next = 3;
                break;
              }
              _context2.next = 2;
              return _this2.loadAcceptedLegalDocuments(LEGAL_DOCUMENTS_ACCEPTED.cookies);
            case 2:
              _context2.next = 4;
              break;
            case 3:
              _context2.next = 4;
              return _this2.loadAcceptedLegalDocuments(_this2.documentsSlugsWithRole(true));
            case 4:
              _this2.isDisabledAcceptedButton = false;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});